'use strict';

var bookingModule = angular.module('t2g.booking', [
  'gettext',
  'ui.router',
  require('t2g.common.services.industrySpecificService').name,
  require('t2g.common.services.modalService').name,
  require('t2g.common.services.notificationService').name,
  require('t2g.common.services.sessionStorage').name,
]);

module.exports = bookingModule;

bookingModule.controller('BookingListCtrl', require('./BookingListCtrl'));

bookingModule.config(function($stateProvider) {
  $stateProvider.state('private.main.booking', {
    url: '/bookings',
    title: 'Bookings',
    templateUrl: '/app/modules/booking/list.html?v=4.5.6',
    controller: 'BookingListCtrl as BookingListCtrl',
    resolve: {
      bookings: function(BookingDA) {
        return BookingDA.getAll().then(function(bookingResponse) {
          return bookingResponse.bookings;
        });
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/booking/bookingModule.js